import { useFormContext, useWatch } from 'react-hook-form';

/**
 * Taken from react-hook-form docs:
 * https://react-hook-form.com/docs/usewatch
 */
export default function useFormValues<
  FormValues extends {
    [k: string]: unknown;
  },
>(): FormValues {
  const { getValues } = useFormContext();
  const watchedValues = useWatch() as unknown as FormValues;

  return {
    ...watchedValues,
    ...getValues(),
  };
}
